if (typeof ReadMore !== "function") {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const contentBlock = this?.firstElementChild;
      const originalHTML = contentBlock.innerHTML;
      const wordLimit = 33;

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = originalHTML;

      let wordCount = 0;
      let reachedLimit = false;

      const truncateNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const words = node.textContent.trim().split(/\s+/);
          if (wordCount + words.length <= wordLimit) {
            wordCount += words.length;
            return node.cloneNode();
          } else {
            const remaining = wordLimit - wordCount;
            const truncatedText = words.slice(0, remaining).join(' ') + '...';
            wordCount = wordLimit;
            reachedLimit = true;
            return document.createTextNode(truncatedText);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const clone = node.cloneNode(false);
          for (const child of node.childNodes) {
            if (reachedLimit) break;
            const truncatedChild = truncateNode(child);
            if (truncatedChild) clone.appendChild(truncatedChild);
          }
          return clone;
        }
        return null;
      };

      const truncatedContent = truncateNode(tempDiv);

      if (wordCount >= wordLimit) {
        contentBlock.innerHTML = '';
        contentBlock.appendChild(truncatedContent);

        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'read-more-toggle';
        toggleBtn.type = 'button';
        toggleBtn.textContent = 'Read more';
        contentBlock.insertAdjacentElement('afterend', toggleBtn);

        let expanded = false;

        toggleBtn.addEventListener('click', () => {
          if (!expanded) {
            contentBlock.innerHTML = originalHTML;
            toggleBtn.className = 'read-more-toggle less';
            toggleBtn.textContent = 'Read less';
          } else {
            contentBlock.innerHTML = '';
            toggleBtn.className = 'read-more-toggle';
            contentBlock.appendChild(truncatedContent.cloneNode(true));
            toggleBtn.textContent = 'Read more';
          }
          expanded = !expanded;
        });
      }
    }
  }

  if (typeof customElements.get("read-more") === "undefined") {
    customElements.define("read-more", ReadMore);
  }
}
